import React from 'react'
import { Grid, Popup } from 'semantic-ui-react'
import DatePicker from '../DatePicker'

const { Row, Column } = Grid

const DateField = ({
  className,
  label,
  value,
  onChange,
  required,
  error,
  validated,
  disabled,
  tooltip,
  children,
  showTime,
  before,
  after,
}) => (
  <Row className={`field ${className}${required && ' required'}`}>
    {label && <Column width={4}><span className="field-label">{label}: </span></Column>}
    <Column width={8}>
      {before}

      <DatePicker
        name={name}
        value={value || ''}
        onChange={onChange}
        required={required || undefined}
        hideTime={!showTime}
        disabled={disabled}
      />
      {after}

      {!!tooltip &&
        <Popup
          trigger={<i className="daicon daicon-Help tooltip" />}
          content={tooltip}
          position="right center"
        />

      }
    </Column>
    <Column width={4}>
      {!!error &&
        <Popup
          trigger={<i className="daicon daicon-Attention error" />}
          content={error}
          position="right center"
        />
      }

      {validated && !error &&
        <i className="daicon daicon-Checkmark success" />
      }
      {children}
    </Column>
  </Row>
)

DateField.defaultProps = {
  className: '',
  validated: false,
  required: false,
  disabled: false,
  error: '',
  tooltip: '',
  children: null,
  showTime: false,
  before: null,
  after: null,
  value: null,
}

DateField.propTypes = {
  className: React.PropTypes.string,
  label: React.PropTypes.string.isRequired,
  name: React.PropTypes.string.isRequired,
  value: React.PropTypes.any,
  onChange: React.PropTypes.func.isRequired,
  validated: React.PropTypes.bool,
  error: React.PropTypes.string,
  tooltip: React.PropTypes.string,
  required: React.PropTypes.bool,
  children: React.PropTypes.any,
  showTime: React.PropTypes.bool,
  before: React.PropTypes.any,
  after: React.PropTypes.any,
  disabled: React.PropTypes.bool,
}

export default DateField



// WEBPACK FOOTER //
// ./src/browser/components/fields/Date.js